export default function () {
    let date = new Date();
    return {
        dateType: 1,
        dates: [
            '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear(),
            '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear()
        ],
        CurrencyId: [],
        DepartmentList: [],
        ManagerList: [],
        Direction: 0,
        ContragentID: 0,
        ContragentName: '',
        ContragentType: 0,
        ContragentSearchTypeId: 0,
        AgreementCode: '',
        RequestNumber: '',
        PaymentReason: '',
        DocumentNumber: '',
        NoDetailedOnly: false,
        AccountNumber: '',
        PaymentOperationID: '',
        CategoryId: '',
        PaymentTypeId: '',
        CashList: [],
        PaymentAccountList: [],
        StatementName: '',
        MinAmount: 0,
        MaxAmount: 0,
        PaySystemTransactionId: '',
      PaymentMethodId: null,
        DateStatement: '',
        KindOfPayId: '',
        RateArticleId: '',
        addCashCheck: false,
        OnlineCashId: 0,
        BillProvideTypeId: 1,
        AddValues: '',
    }
}